import InteractiveMap from './InteractiveMap';

export default InteractiveMap;
